








































































































import { Component, Vue, Prop } from "vue-property-decorator";
import { SurveyStatusResult, User, UserProfile } from "@/interfaces";
import { AuthModule } from "@/store";

import { date } from "quasar";
import ReminderDialog from "@/components/ReminderDialog.vue";

@Component
export default class MenuLeftAdmin extends Vue {
  @Prop({ type: Boolean, default: () => false })
  value!: boolean;

  @AuthModule.bindings.State
  previewStatus!: SurveyStatusResult;

  @AuthModule.bindings.State
  previewUser!: UserProfile;

  @AuthModule.bindings.State
  loadingUsers!: boolean;

  @AuthModule.bindings.State
  loadingUser!: boolean;

  @AuthModule.bindings.State
  users!: User[];

  @AuthModule.bindings.Getter
  isAdministrator!: boolean;

  user: User | null = null;

  async mounted() {
    try {
      await AuthModule.store.getUsers();
      if (this.users.length > 0) {
        this.user = this.users[0];
        await AuthModule.store.getUser(this.user.id);
      }
    } catch (error) {
      console.log(error);
    }
  }

  onUserChange() {
    if (this.user) {
      AuthModule.store.getUser(this.user.id);
    }
  }

  toggleMenu() {
    this.$emit("input", !this.value);
  }

  getParsedDate(updated: string) {
    return date.formatDate(updated, "DD/MM/YYYY");
  }

  onSendSurveyClick() {
    if (this.user) {
      this.$q.dialog({
        component: ReminderDialog,
        parent: this,
        userId: this.user.id,
      });
    }
  }
}
